import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const useAddersViewModel = () => {
  const stateManager = useComponentState();

  const [adders, setAdders] = useState([]);
  const [recentAdders, setRecentAdders] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const GET_ADDERS_UUID = createUUID();
  const GET_RECENT_ADDERS_UUID = createUUID();
  const HANDLE_DELETE_ADDER_UUID = createUUID();

  const handleSetData = (data) => {
    setAdders(data);
  };

  const getAdders = ({ top, skip, search = "" }) => {
    stateManager.abort(GET_ADDERS_UUID);
    return stateManager.run(() => {
      return homeService.adders.getAll({
        sort: "name",
        top,
        skip,
        filters: { name: { contains: search } },
      });
    }, GET_ADDERS_UUID);
  };

  const getRecentAdders = ({ sort, filters, top }) => {
    stateManager.abort(GET_RECENT_ADDERS_UUID);
    return stateManager.run(async () => {
      return homeService.adders.getAll({ sort, filters, top });
    }, GET_RECENT_ADDERS_UUID);
  };

  const handleDeleteAdder = (data) => {
    stateManager.abort(HANDLE_DELETE_ADDER_UUID);
    stateManager.run(async () => {
      const response = await homeService.adders.delete({
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${data.name} was deleted successfully.`,
          },
          failure: {
            text: `Failed to delete ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
    }, HANDLE_DELETE_ADDER_UUID);
  };

  return {
    adders,
    refresh,
    getAdders,
    handleSetData,
    handleDeleteAdder,
    recentAdders,
    setRecentAdders,
    getRecentAdders,
    isLoading: stateManager.isBusy(),
  };
};
